import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const showMore: SxStyle = {
  ml: 1,
  cursor: 'pointer',
  textWrap: 'nowrap',
};
